import React, { useState, useEffect } from 'react';

const Pagination = ({ nPages, currentPage, setCurrentPage, totalRecords, pageLength, setPageLength }) => {
    // State to store the max number of visible pages based on screen width
    const [maxVisiblePages, setMaxVisiblePages] = useState(
        pageLength ? pageLength : 10
    );
    const [localInput, setLocalInput] = useState(String(pageLength ? pageLength : 10));
    useEffect(() => {
        setMaxVisiblePages(pageLength ?? 10);
        setLocalInput(String(pageLength ?? 10));
    }, [pageLength]);


    const pageNumbers = [...Array(nPages + 1).keys()].slice(1);

    const nextPage = () => {
        if (currentPage !== nPages) setCurrentPage(currentPage + 1);
    };

    const prevPage = () => {
        if (currentPage !== 1) setCurrentPage(currentPage - 1);
    };
    const handleInputChange = (e) => {
        setLocalInput(e.target.value); // Allow empty string
    };
    const handleInputBlur = () => {
        const newVal = parseInt(localInput, 10);
        if (!isNaN(newVal) && newVal > 0) {
            setMaxVisiblePages(newVal);
            setCurrentPage(1); // reset page
            if (setPageLength) setPageLength(newVal); // 🔁 update parent
        } else {
            setLocalInput(String(maxVisiblePages)); // Reset to last valid value
        }
    };

    const renderPageNumbers = () => {
        if (nPages <= 0) {
            return (
                <li className="page-item disabled">
                    <span className="page-link">0</span>
                </li>
            );
        } else if (nPages <= maxVisiblePages) {
            return pageNumbers.map(pgNumber => (
                <li key={pgNumber} className={`page-item ${currentPage === pgNumber ? 'active' : ''}`}>
                    <a onClick={() => setCurrentPage(pgNumber)} style={{ cursor: 'pointer' }} className='page-link'>
                        {pgNumber}
                    </a>
                </li>
            ));
        } else {
            const pageRangeStart = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
            const pageRangeEnd = Math.min(pageRangeStart + maxVisiblePages - 1, nPages);
            const pagesToDisplay = [...Array(pageRangeEnd - pageRangeStart + 1).keys()].map(page => page + pageRangeStart);

            return (
                <>
                    {pageRangeStart > 1 && (
                        <>
                            <li className="page-item">
                                <a onClick={() => setCurrentPage(1)} style={{ cursor: 'pointer' }} className='page-link'>
                                    1
                                </a>
                            </li>
                            {pageRangeStart > 2 && (
                                <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                </li>
                            )}
                        </>
                    )}
                    {pagesToDisplay.map(pgNumber => (
                        <li key={pgNumber} className={`page-item ${currentPage === pgNumber ? 'active' : ''}`}>
                            <a onClick={() => setCurrentPage(pgNumber)} style={{ cursor: 'pointer' }} className='page-link'>
                                {pgNumber}
                            </a>
                        </li>
                    ))}
                    {pageRangeEnd < nPages && (
                        <>
                            {pageRangeEnd < nPages - 1 && (
                                <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                </li>
                            )}
                            <li className="page-item">
                                <a onClick={() => setCurrentPage(nPages)} style={{ cursor: 'pointer' }} className='page-link'>
                                    {nPages}
                                </a>
                            </li>
                        </>
                    )}
                </>
            );
        }
    };

    return (
        <>
            <p style={{ float: 'left' }}>Shown
                <input
                    style={{ width: '10%', textAlign: 'center' }}
                    type='number'
                    value={localInput}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                />
                records out of {totalRecords} </p>

            <nav style={{ float: 'right' }}>
                <ul className="pagination">
                    <li className="page-item">
                        <a className="page-link" style={{ cursor: 'pointer' }} onClick={prevPage}>
                            Previous
                        </a>
                    </li>
                    {renderPageNumbers()}
                    <li className="page-item">
                        <a className="page-link" style={{ cursor: 'pointer' }} onClick={nextPage}>
                            Next
                        </a>
                    </li>
                </ul>
            </nav>
        </>
    );
};

const styles = `
    .pagination .page-link {
        background-color: #ffffff;  
        border: 1px solid #744587; 
        color: #744587;          
        font-weight: bold;
        transition: background-color 0.3s ease, color 0.3s ease;
    }

    .pagination .page-item.active .page-link {
        background-color: #744587; 
        color: #ffffff;          
        border-color: #744587;
    }

    .pagination .page-link:hover {
        background-color: #744587;
        color: #ffffff;            
    }

    .pagination .page-item.disabled .page-link {
        background-color: #ffffff;
        color: #ccc;
        border: 1px solid #f3d97f;
    }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default Pagination;
